import { nowLang, defaultLang } from "@language/index";
import { setBg } from "@utiles/index";

export const getImage = (name) => {
  return new URL(`../assets/images/${name}`, import.meta.url).href;
};

// 站点配置信息
export const websiteConfig = {
  // 攻略站素材包
  material: {
    default: {
      backbtn: getImage("backbtn.png"),
      closebtn: getImage("closebtn.png"),
      homeicon: getImage("homeicon.png"),
      likebtn_s: getImage("likebtn_s.png"),
      likebtn: getImage("likebtn.png"),
      likeicon: getImage("likeicon.png"),
      navbtn: getImage("navbtn.png"),
      searchbtn: getImage("searchbtn.png"),
    },
    api: {},
  },
  // 攻略站语言包json
  language: {
    default: {
      "zh-CN": {
        searchTitle: "搜索",
        noResult: "暂无搜索结果，请尝试搜索其他内容",
        recommendNews: "最新资讯",
        searchTips: "输入内容开始搜索",
        noArticle: "敬请期待",
        getMore: "加载更多",
        confirm: "确定",
        cancel: "取消",
        detail: "详情",
        likeFail: "操作失败，请稍后再试",
        siteError: "站点维护中，请稍后再试",
        zhenrong: "工具",
      },
      "zh-TW": {
        searchTitle: "搜索",
        noResult: "暫無搜索結果，請嘗試搜索其他內容",
        recommendNews: "最新資訊",
        searchTips: "輸入內容開始搜索",
        noArticle: "敬請期待",
        getMore: "載入更多",
        confirm: "確定",
        cancel: "取消",
        detail: "詳情",
        likeFail: "操作失敗，請稍後再試",
        siteError: "網站維護中，請稍後再試",
        zhenrong: "工具",
      },
      "en-US": {
        searchTitle: "Search",
        noResult: "No results. Please try another keyword.",
        recommendNews: "Latest News",
        searchTips: "Search...",
        noArticle: "Coming Soon",
        getMore: "More",
        confirm: "OK",
        cancel: "Cancel",
        detail: "Details",
        likeFail: "Access denied. Retry later.",
        siteError: "Under maintenance. Retry later.",
        zhenrong: "HERO PROFILES",
      },
      "ar-SA": {
        searchTitle: "بحث",
        noResult: "لا توجد نتائج. يرجى محاولة البحث بكلمة مفتاحية أخرى.",
        recommendNews: "أحدث الأخبار",
        searchTips: "بحث...",
        noArticle: "قريبًا",
        getMore: "المزيد",
        confirm: "موافق",
        cancel: "إلغاء",
        detail: "التفاصيل",
        likeFail: "تم رفض الوصول. أعد المحاولة لاحقًا.",
        siteError: "تحت الصيانة. أعد المحاولة لاحقًا.",
      },
      "de-DE": {
        searchTitle: "Suchen",
        noResult:
          "Keine Ergebnisse. Bitte versuche es mit einem anderen Schlüsselwort.",
        recommendNews: "Neueste Nachrichten",
        searchTips: "Suchen ...",
        noArticle: "Demnächst",
        getMore: "Mehr",
        confirm: "OK",
        cancel: "Abbrechen",
        detail: "Details",
        likeFail: "Zugriff abgelehnt. Versuche es später noch einmal.",
        siteError: "Wird gewartet. Versuche es später noch einmal.",
      },
      "es-ES": {
        searchTitle: "Buscar",
        noResult: "No hay resultados. Prueba con otra palabra clave.",
        recommendNews: "Últimas noticias",
        searchTips: "Buscar...",
        noArticle: "Próximamente",
        getMore: "Más",
        confirm: "OK",
        cancel: "Cancelar",
        detail: "Detalles",
        likeFail: "Acceso denegado. Vuelve a intentarlo más tarde.",
        siteError: "En mantenimiento. Vuelve a intentarlo más tarde.",
      },
      "fr-FR": {
        searchTitle: "Recherche",
        noResult: "Aucun résultat. Veuillez essayer un autre mot-clé.",
        recommendNews: "Dernières nouvelles",
        searchTips: "Rechercher...",
        noArticle: "Bientôt disponible",
        getMore: "Plus d'informations",
        confirm: "OK",
        cancel: "Annuler",
        detail: "Détails",
        likeFail: "Accès refusé. Réessayer plus tard.",
        siteError: "En cours de maintenance. Réessayer plus tard.",
      },
      "id-ID": {
        searchTitle: "Cari",
        noResult: "Tidak ada hasil pencarian. Silakan coba cari konten lain",
        recommendNews: "Info Terbaru",
        searchTips: "Masukkan konten dan mulai cari",
        noArticle: "Silakan nantikan",
        getMore: "Muat lebih banyak",
        confirm: "Konfirmasi",
        cancel: "Batal",
        detail: "Detail",
        likeFail: "Aksi gagal. Silakan coba lagi",
        siteError: "Sedang maintenance, silakan coba lagi nanti",
      },
      "it-IT": {
        searchTitle: "Cerca",
        noResult: "Nessun risultato. Prova un'altra parola chiave.",
        recommendNews: "Ultime Notizie",
        searchTips: "Cerca...",
        noArticle: "Prossimamente",
        getMore: "Più",
        confirm: "OK",
        cancel: "Annulla",
        detail: "Dettagli",
        likeFail: "Accesso negato. Riprova più tardi.",
        siteError: "In manutenzione. Riprova più tardi.",
      },
      "ja-JP": {
        searchTitle: "検索",
        noResult: "関連する結果がありません。他の内容を入力してください。",
        recommendNews: "最新ニュース",
        searchTips: "検索したい内容を入力してください。",
        noArticle: "こうご期待",
        getMore: "もっと見る",
        confirm: "確定",
        cancel: "キャンセル",
        detail: "詳細情報",
        likeFail: "操作失敗。しばらく待ってからもう一度試してください。",
        siteError:
          "メンテナンス中です。しばらく待ってからもう一度試してください。",
        zhenrong: "キャラ&陣営",
      },
      "ko-KR": {
        searchTitle: "검색",
        noResult: "검색 결과가 없습니다. 다른 내용을 검색해보세요.",
        recommendNews: "최신 정보",
        searchTips: "검색할 내용을 입력하세요",
        noArticle: "기대해주세요",
        getMore: "로딩 중",
        confirm: "확인",
        cancel: "취소",
        detail: "상세",
        likeFail: "조작 실패. 잠시 후 다시 시도하세요",
        siteError: "점검 중. 잠시 후 다시 시도하세요",
        zhenrong: "영웅 정보",
      },
      "pl-PL": {
        searchTitle: "Szukaj",
        noResult: "Brak wyników. Spróbuj innej frazy.",
        recommendNews: "Najnowsze wiadomości",
        searchTips: "Szukaj...",
        noArticle: "Już wkrótce",
        getMore: "Więcej",
        confirm: "OK",
        cancel: "Anuluj",
        detail: "Szczegóły",
        likeFail: "Odmowa dostępu. Spróbuj później.",
        siteError: "Przerwa techniczna. Spróbuj później.",
      },
      "pt-PT": {
        searchTitle: "Procurar",
        noResult: "Sem resultados. Tente outra palavra.",
        recommendNews: "Notícias recentes",
        searchTips: "Procurar…",
        noArticle: "Em breve",
        getMore: "Mais",
        confirm: "OK",
        cancel: "Cancelar",
        detail: "Detalhes",
        likeFail: "Acesso negado. Tente mais tarde.",
        siteError: "Em manutenção. Tente mais tarde.",
      },
      "ru-RU": {
        searchTitle: "Поиск",
        noResult: "Ничего не найдено, попробуйте другое слово.",
        recommendNews: "Последние новости",
        searchTips: "Поиск...",
        noArticle: "Скоро появится",
        getMore: "Ещё",
        confirm: "Принять",
        cancel: "Отмена",
        detail: "Подробнее",
        likeFail: "Доступ запрещен, повторите позже.",
        siteError: "На обслуживании, повторите позже.",
      },
      "th-TH": {
        searchTitle: "ค้นหา",
        noResult: "ไม่พบผลลัพธ์ใดๆ โปรดลองค้นหาเนื้อหาอื่น",
        recommendNews: "ข่าวสารล่าสุด",
        searchTips: "ป้อนเนื้อหาเพื่อเริ่มค้นหา",
        noArticle: "เร็วๆ นี้",
        getMore: "ดูเพิ่มเติม",
        confirm: "ยืนยัน",
        cancel: "ยกเลิก",
        detail: "รายละเอียด",
        likeFail: "ทำรายการไม่สำเร็จ โปรดลองใหม่ภายหลัง",
        siteError: "กำลังปรับปรุง โปรดลองใหม่ภายหลัง",
      },
      "tr-TR": {
        searchTitle: "Ara",
        noResult: "Sonuç yok. Lütfen başka bir anahtar kelime deneyin.",
        recommendNews: "En Son Haberler",
        searchTips: "Aranıyor...",
        noArticle: "Çok yakında",
        getMore: "Dahası",
        confirm: "TAMAM",
        cancel: "İptal Et",
        detail: "Ayrıntılar",
        likeFail: "Erişim reddedildi. Daha sonra tekrar deneyin.",
        siteError: "Bakımda. Daha sonra tekrar deneyin.",
      },
      "vi-VN": {
        searchTitle: "Tìm kiếm",
        noResult: "Chưa có kết quả tìm kiếm, hãy thử tìm kiếm nội dung khác",
        recommendNews: "Nhập nội dung để tìm kiếm",
        searchTips: "Nhập nội dung để tìm kiếm",
        noArticle: "Vui lòng chờ đợi",
        getMore: "Tải thêm",
        confirm: "Xác nhận",
        cancel: "Hủy",
        detail: "Chi tiết",
        likeFail: "Thao tác thất bại, vui lòng thử lại sau",
        siteError: "Đang bảo trì, vui lòng thử lại sau",
      },
    },
    api: {},
  },
};

export const initMaterialConfig = (materialConfig) => {
  websiteConfig.material.api = materialConfig;
};

export const initLanguageConfig = (langConfig) => {
  websiteConfig.language.api = langConfig;
};

export const getIco = (key: string) => {
  return (
    websiteConfig.material.api?.[key] ||
    websiteConfig.material.default?.[key] ||
    ""
  );
};

export const getIcoOfBg = (key: string) => {
  if (getIco(key)) {
    return setBg(getIco(key));
  }
  return "";
};

export const getText = (key: string) => {
  return (
    websiteConfig.language.api?.[key] ||
    websiteConfig.language.default?.[nowLang.value]?.[key] ||
    websiteConfig.language.default?.[defaultLang.value]?.[key] ||
    ""
  );
};
